import React from "react";
import { connect } from "react-redux";
import IngresoActions from "../../../stores/ingreso/Actions";
import CustomInput from "../../../components/CustomForm/CustomInput";
import CustomSelect from "../../../components/CustomForm/CustomSelect";
import {
  FormWrapper,
  Form,
  FormGroup,
} from "../../../components/CustomForm/FormStyles";
import useEmpresa from "../../../hooks/useEmpresa";
import {
  dataMotivoEgreso,
  dataCausaInternamiento,
} from "../../../utils/LocalData";
import {
  calcularDiasCalendario,
} from "../../../utils/DateUtils";
import { isEmptyValue } from "../../../utils/StringUtil";
import {
  MAXIMO_DIAS_PERMITIDOS_CIERRE,
  MENSAJE_CIERRE_CUENTA,
} from "../utils/IngresoConstant";
import { DATE_FORMATS } from "../../../utils/Constant";
import moment from "moment";
import { obtenerTiposServicios } from "../utils/IngresoUtils";

const AutorizacionIngresoForm = (props) => {
  const { formCierreCuentasData } = props;

  const empresa = useEmpresa();

  const handleAlertaDias = (mensaje, showDetalleIngreso = false) => {
    props.formCierreCuentas({
      ...formCierreCuentasData,
      alertConfig: {
        type: "info",
        title: "¡Hola!",
        message: mensaje,
        onConfirm: () => {
          props.formCierreCuentas({
            ...formCierreCuentasData,
            showDetalleIngreso,
            showAlert: false,
          });
        },
      },
      showDetalleIngreso,
      showAlert: true,
    });
  };

  const onStateChange =
    (key, format = null) =>
    (value) => {
      props.formCierreCuentas({
        ...formCierreCuentasData,
        [key]: format ? format(value) : value,
      });

      if (
        key === "codigoPss" &&
        !isEmptyValue(formCierreCuentasData?.tipoPss)
      ) {
        props.consultarReclamantes({
          formCierreCuentasData,
          compania: empresa?.CODIGO,
          tipoReclamante: formCierreCuentasData?.tipoPss,
          codigoReclamante: format ? format(value) : value,
        });
        return;
      }

      if (key === "fechaSalida") {
        const { tienePrecertificacion, aplicaExcepcion, fechaServicio } =
          formCierreCuentasData;

        if (
          moment(fechaServicio)
            .startOf("day")
            .isAfter(moment(value).startOf("day"))
        ) {
          handleAlertaDias(
            MENSAJE_CIERRE_CUENTA.FECHA_SERVICIO_EXCEDE_SALIDA,
            true
          );
          return;
        }

        if (moment(value).startOf("day").isAfter(moment().startOf("day"))) {
          handleAlertaDias(
            MENSAJE_CIERRE_CUENTA.FECHA_SALIDA_EXCEDE_ACTUAL,
            true
          );
          return;
        }

        const fechaIngreso = moment(fechaServicio);

        const diasConExcepcionCalendario = calcularDiasCalendario(
          fechaIngreso.format(DATE_FORMATS.middledash_ymd),
          value
        );

        const diasConPrecertificacionCalendario = calcularDiasCalendario(
          fechaIngreso.format(DATE_FORMATS.middledash_ymd),
          value
        );

        const diasSinPrecertificacionCalendario = calcularDiasCalendario(
          fechaIngreso.format(DATE_FORMATS.middledash_ymd),
          value
        );

        if (
          aplicaExcepcion &&
          diasConExcepcionCalendario >
            MAXIMO_DIAS_PERMITIDOS_CIERRE.CON_EXEPCION_CALENDARIO
        ) {
          handleAlertaDias(
            MENSAJE_CIERRE_CUENTA.DIAS_CALENDARIO_EXCEDIDOS_EXCEPCION,
            true
          );
          return;
        }

        if (
          tienePrecertificacion &&
          diasConPrecertificacionCalendario >
            MAXIMO_DIAS_PERMITIDOS_CIERRE.CON_PRECERTIFICACION_CALENDARIO
        ) {
          handleAlertaDias(MENSAJE_CIERRE_CUENTA.DIAS_CALENDARIO_EXCEDIDOS, true);
          return;
        }

        if (
          !tienePrecertificacion &&
          diasSinPrecertificacionCalendario >
            MAXIMO_DIAS_PERMITIDOS_CIERRE.SIN_PRECERTIFICACION_CALENDARIO
        ) {
          handleAlertaDias(MENSAJE_CIERRE_CUENTA.DIAS_CALENDARIO_EXCEDIDOS, true);
          return;
        }
      }
    };

  return (
    <FormWrapper borderColor={empresa?.COLOR_PRINCIPAL}>
      <Form>
        <FormGroup>
          <CustomInput
            type={"text"}
            placeholder={"Número de ingreso"}
            label={"Número de ingreso"}
            value={formCierreCuentasData?.secuencialIngreso}
            onChange={onStateChange("secuencialIngreso")}
            disabled={true}
          />
        </FormGroup>
        <FormGroup>
          <CustomInput
            type={"date"}
            placeholder={"Fecha salida"}
            label={"Fecha salida"}
            value={formCierreCuentasData?.fechaSalida}
            onChange={onStateChange("fechaSalida")}
            required={true}
            showRequired={formCierreCuentasData?.showRequired}
            disabled={false}
            minDate={formCierreCuentasData?.fechaServicio}
            maxDate={moment().format(DATE_FORMATS.middledash_ymd)}
          />
        </FormGroup>
        <FormGroup>
          <CustomSelect
            options={dataMotivoEgreso}
            showDefaultOption={true}
            label={"Motivo Egreso"}
            value={formCierreCuentasData?.motivoEgreso}
            onChange={onStateChange("motivoEgreso")}
            required={true}
            showRequired={formCierreCuentasData?.showRequired}
            disabled={false}
          />
        </FormGroup>
        <FormGroup>
          <CustomSelect
            options={dataCausaInternamiento}
            showDefaultOption={true}
            label={"Causa de internamiento"}
            value={formCierreCuentasData?.causaInternamiento}
            onChange={onStateChange("causaInternamiento")}
            required={true}
            showRequired={formCierreCuentasData?.showRequired}
            disabled={false}
          />
        </FormGroup>
        <FormGroup>
          <CustomInput
            type={"date"}
            placeholder={"Fecha de servicio"}
            label={"Fecha de servicio"}
            value={formCierreCuentasData?.fechaServicio}
            onChange={onStateChange("fechaServicio")}
            disabled={true}
          />
        </FormGroup>
        <FormGroup>
          <CustomSelect
            options={obtenerTiposServicios(
              formCierreCuentasData?.tienePrecertificacion,
              formCierreCuentasData?.tipoServicioOrigen
            )}
            label={"Tipo de Servicio"}
            value={formCierreCuentasData?.tipoServicio}
            onChange={onStateChange("tipoServicio")}
            required={true}
            showRequired={formCierreCuentasData?.showRequired}
            showDefaultOption={true}
            disabled={formCierreCuentasData?.tienePrecertificacion}
          />
        </FormGroup>
      </Form>
    </FormWrapper>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,

  formCierreCuentasData: state.ingreso.formCierreCuentasData,
  formCierreCuentasLoading: state.ingreso.formCierreCuentasLoading,

  consultarReclamantesLoading: state.ingreso.consultarReclamantesLoading,
});

const mapDispatchToProps = {
  formCierreCuentas: IngresoActions.formCierreCuentas,
  consultarReclamantes: IngresoActions.consultarReclamantes,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(AutorizacionIngresoForm);
